export type Permission = `${keyof typeof PermissionType}.${
  | keyof typeof BaseAction
  | keyof typeof ProfileAction
  | keyof typeof OperationAction
  | keyof typeof AssetAction
  | keyof typeof PeripheralOperationAction
  | keyof typeof PeripheralBoardingOperationAction
  | keyof typeof VehicleBoardingOperationAction
  | keyof typeof PlanAction
  | keyof typeof RemoteCommandOperationAction}`;

export enum PermissionType {
  Organization = 0,
  Profile = 1,
  Hub = 2,
  Fleet = 3,
  Asset = 4,
  Alert = 5,
  Integration = 6,
  Job = 7,
  'Pilot.PDR.Jobs' = 8,
  Order = 9,
  Insight = 10,
  Inspection = 11,
  Peripheral = 12,
  'Boarding.Peripheral' = 13,
  Entitlement = 14,
  License = 15,
  RemoteCommand = 16,
  'Boarding.Vehicle' = 17,
}

export enum BaseAction {
  Create = 0,
  Read = 1,
  Update = 2,
  Delete = 3,
  Invite = 4,
  List = 5,
}

export enum ProfileAction {
  AssignProfile = 0,
  UnassignProfile = 1,
}

export enum OperationAction {
  PerformOperation = 0,
  ModifyProtectedValues = 1,
}

export enum AssetAction {
  ModifyHardwareID = 0,
  ManageHardware = 1,
  SetHub = 2,
  SetFleet = 3,
  'Update.State.Availability' = 4,
}

export enum PeripheralBoardingOperationAction {
  Offboard = 0,
  BatchOnboardStatus = 1,
  BatchOnboard = 2,
}

export enum PeripheralOperationAction {
  LinkToVehicle = 0,
  UnlinkFromVIN = 1,
  SetFleet = 2,
}

export enum VehicleBoardingOperationAction {
  BatchOffBoard = 0,
}

export enum PermissionScope {
  SELF = 'Self',
  ALL = 'All',
  NONE = 'None',
}
export enum PlanAction {
  Get = 0,
}

export enum RemoteCommandOperationAction {
  Execute = 0,
}
